import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWall2Left: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-wall-2-left, align left"} maskId="square-filled-radius-0-stroke-1-IconArrowWall2Left"><path fillRule="evenodd" clipRule="evenodd" d="M4 4V11.7929L9.25 6.54289L9.95711 7.25L5.70711 11.5H21V12.5H5.7071L9.95711 16.75L9.25 17.4571L4 12.2071V20H3V4H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowWall2Left;
